import get from 'lodash/get'
import transform from 'lodash/transform'
import map from 'lodash/map'
import every from 'lodash/every'
import each from 'lodash/each'
import filter from 'lodash/filter'
import find from 'lodash/find'

let installed = false

const formLikeKeys = function (obj) {
  return filter(
    map(obj, (datum, key) => {
      return key.substr(0, 1) !== '_' &&
        datum &&
        typeof datum === 'object' &&
        Object.prototype.hasOwnProperty.call(datum, 'valid') &&
        Object.prototype.hasOwnProperty.call(datum, 'value')
        ? key
        : null
    })
  )
}

export default {
  install(Vue) {
    if (installed) {
      return
    }

    installed = true

    Vue.mixin({
      created() {
        if (this.$options.validation) {
          this.$data.$validations = {
            keys: [...formLikeKeys(this), ...Object.keys(get(this.$options, ['validation', 'topics'], {}))],
            results: [],
            triggered: {}
          }

          this.$validate()
        }
      },

      mounted() {
        if (this.$options.validation) {
          this._watchValidationTriggers()
        }
      },

      updated() {
        if (this.$options.validation) {
          this._watchValidationTriggers()
        }
      },

      methods: {
        _watchValidationTriggers() {
          this.$data.$validations.triggered = {
            ...this.$data.$validations.triggered,
            ...transform(this.$refs, (acc, comp, ref) => {
              const event = get(this.$options, ['validation', 'refs', ref], false)

              if (event && comp) {
                comp.$on(event, (e) => {
                  this.$validate({ throughTrigger: ref })
                })
              }

              acc[ref] = !!this.$data.$validations.triggered[ref]
            })
          }
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$validations', {
      get() {
        return this.$data.$validations.results
      }
    })

    Vue.prototype.$valid = function ({ after: ref, topics }) {
      return !this.$invalid({ after: ref, topics })
    }

    Vue.prototype.$invalid = function ({ after: refOrRefs, topics }) {
      let val = false
      const hasRef = !refOrRefs

      const anyTriggered = () => {
        const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs]

        return !!find(refs, (ref) => this.$data.$validations.triggered[ref])
      }

      if (hasRef) {
        // Calculate immediately because this does not depend on a ref
        const validations = this._validate()

        val = !every(map(topics, (t) => get(validations, [t, 'valid'], false)))
      } else if (anyTriggered()) {
        // Use the cached validations in this.$validations
        try {
          val = !every(map(topics, (t) => this.$validations[t].valid))
        } catch (e) {
          Vue.util.warn(`Could not find a validation value for one or more topics ${topics}.`)
        }
      }

      return val
    }

    Vue.prototype._validate = function () {
      // Early call to validate before $data has been created
      const normalize = function (val) {
        let normalized = { valid: false, value: '' }

        if (typeof val === 'boolean') {
          normalized.valid = val
        }

        if (typeof val === 'object') {
          normalized = Object.assign({}, normalized, val)
        }

        return normalized
      }

      const results = {}

      each(get(this, ['$data', '$validations', 'keys'], []), (key) => {
        let val = null

        try {
          val = this[key] ? this[key] : this.$options.validation.topics[key].call(this)
        } catch (e) {
          Vue.util.warn(`Could not find ${key} in the component validation.topics, check your component`)
        }

        results[key] = normalize(val)
      })

      return results
    }

    Vue.prototype.$validate = function (options = {}) {
      this.$data.$validations.results = this._validate()

      if (options.throughTrigger) {
        this.$data.$validations.triggered[options.throughTrigger] = true
        this.$forceUpdate()
      }
    }
  }
}
